export class ChartSerializer {
    static saveTemplate(name, data) {
        const templates = this.getAllTemplates();
        templates.set(name, { name, ...data });
        localStorage.setItem("vninvestcharts-widget_templates", JSON.stringify(Array.from(templates.entries())));
    }
    static loadTemplate(name) {
        const templates = this.getAllTemplates();
        return templates.get(name) || null;
    }
    static getAllTemplates() {
        try {
            const raw = localStorage.getItem("vninvestcharts-widget_templates");
            if (!raw)
                return new Map();
            const arr = JSON.parse(raw);
            return new Map(arr);
        }
        catch {
            return new Map();
        }
    }
    static deleteTemplate(name) {
        const templates = this.getAllTemplates();
        templates.delete(name);
        localStorage.setItem("vninvestcharts-widget_templates", JSON.stringify(Array.from(templates.entries())));
    }
}
